// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2jlaB","card__label":"Card_card__label__1bxgv","card__body":"Card_card__body__1KPdd"};